// extracted by mini-css-extract-plugin
export default {"container":"Donate_container__UcZ9t","inputs":"Donate_inputs__bcNXz","input":"Donate_input__G11Z3","qr":"Donate_qr__g9IeR"};